// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Raleway", sans-serif;
}

canvas {
  display: block;
  border: none;
  margin: 0;
  padding: 0;
}

:root {
  --background-color: #eae8e4;
  --walls-canvas: #4c5559;
  --background-canvas: #DDD8CF;
  --buttons: #6B7B84;
  --buttons-hover: #58656c;
  --navbar-color: #29435eff;
  --navbar-color-hover: #25415e;
  --navbar-text: #899ca8;
  --navbar-text-hover: #58656c;
  --interface-color: #E97451;
  --interface-box: #CC5500;
  --text: #000000;
}

[data-theme="dark"] {
  --background-color: #15171b;
  --walls-canvas: #b3aaa6;
  --background-canvas: #222730;
  --buttons: #94847b;
  --buttons-hover: #a79a93;
  --navbar-color: #090F15;
  --navbar-color-hover: #0f1923;
  --navbar-text: #766357;
  --navbar-text-hover: #a79a93;
  --interface-color: #168bae;
  --interface-box: #33aaff;
  --text: #ffffff;
}

body {
  background-color: var(--background-color);
}

.title {
  color: #ffffff;
  font-size: 3rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2rem;
}

.app {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.react-logo {
  width: 100px;
  height: 100px;
  animation: spin 15s linear infinite;
}

.whiteboard-page {
  height: 100vh;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 80px;
  /* Push center content down to avoid overlapping with title */
}

/* Top-left back link */
.top-left {
  position: absolute;
  top: 20px;
  left: 20px;
}

.back-link {
  text-decoration: underline;
  color: var(--navbar-color);
}

/* Title at top center */
.page-title {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
}

/* Centered content below title */
.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/AppStyles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Raleway\", sans-serif;\n}\n\ncanvas {\n  display: block;\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --background-color: #eae8e4;\n  --walls-canvas: #4c5559;\n  --background-canvas: #DDD8CF;\n  --buttons: #6B7B84;\n  --buttons-hover: #58656c;\n  --navbar-color: #29435eff;\n  --navbar-color-hover: #25415e;\n  --navbar-text: #899ca8;\n  --navbar-text-hover: #58656c;\n  --interface-color: #E97451;\n  --interface-box: #CC5500;\n  --text: #000000;\n}\n\n[data-theme=\"dark\"] {\n  --background-color: #15171b;\n  --walls-canvas: #b3aaa6;\n  --background-canvas: #222730;\n  --buttons: #94847b;\n  --buttons-hover: #a79a93;\n  --navbar-color: #090F15;\n  --navbar-color-hover: #0f1923;\n  --navbar-text: #766357;\n  --navbar-text-hover: #a79a93;\n  --interface-color: #168bae;\n  --interface-box: #33aaff;\n  --text: #ffffff;\n}\n\nbody {\n  background-color: var(--background-color);\n}\n\n.title {\n  color: #ffffff;\n  font-size: 3rem;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.react-logo {\n  width: 100px;\n  height: 100px;\n  animation: spin 15s linear infinite;\n}\n\n.whiteboard-page {\n  height: 100vh;\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding-top: 80px;\n  /* Push center content down to avoid overlapping with title */\n}\n\n/* Top-left back link */\n.top-left {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n}\n\n.back-link {\n  text-decoration: underline;\n  color: var(--navbar-color);\n}\n\n/* Title at top center */\n.page-title {\n  position: absolute;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  margin: 0;\n}\n\n/* Centered content below title */\n.center-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
